import { Card, Input } from "semantic-ui-react";

import { useState } from "react";
import { useTranslation } from "react-i18next";

import { firebase } from "astrid-firebase";
import useHttpsCallable from "astrid-hooks/src/useHttpsCallable";

import PrimaryButton from "../../../../ui/components/Buttons/PrimaryButton";
import ErrorMessage from "../../../../ui/components/Messages/ErrorMessage";
import Message from "../../../../ui/components/Messages/Message";

export default function ContractorExternalUploadLogin({ contractorId }) {
	const { t } = useTranslation();

	const [password, setPassword] = useState("");
	const [wrongPassword, setWrongPassword] = useState(false);

	const [signIn, loading, error] = useHttpsCallable(firebase.functions(), "contractors-signIn");

	const onLogin = async () => {
		const result = await signIn({ password, contractorId });

		setWrongPassword(!(result instanceof Error) && !result.data?.token);

		if (result.data?.token) {
			await firebase.auth().signInWithCustomToken(result.data.token);
		}
	};

	return (
		<Card centered fluid>
			<Card.Content>
				<Input
					type="password"
					value={password}
					placeholder={t("password", "Password")}
					onChange={(e) => setPassword(e.target.value)}
					fluid
				/>

				{wrongPassword && (
					<Message error size="mini">
						{t("incorrectPassword", "Incorrect password")}
					</Message>
				)}

				{error && <ErrorMessage error={error} />}
			</Card.Content>

			<Card.Content extra>
				<PrimaryButton loading={loading} disabled={loading} onClick={() => onLogin()}>
					{t("login", "Login")}
				</PrimaryButton>
			</Card.Content>
		</Card>
	);
}
